<template>
  <div>
    <div v-if="item.type && item.type === 2" class="number-container">
      <el-input
        style="width: calc(50% - 10px)"
        size="medium"
        clearable
        type="number"
        v-model.number="startNumber"
        class="input"
        placeholder="开始数值"
        @change="queryListWithin"
      ></el-input>
      <i class="el-icon-minus" style="color: #86909c"></i>
      <el-input
        style="width: calc(50% - 10px)"
        size="medium"
        clearable
        class="input"
        v-model.number="finishNumber"
        placeholder="结束数值"
        @change="queryListWithin"
      ></el-input>
    </div>
    <div v-else>
      <div v-if="disabled" class="disabledCss">
        {{
          formData[item.code]
            ? formData[item.code]
                .toFixed(item.format * 1)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00"
        }}
      </div>
      <!-- 从input换成blur  目前没有遇到bug  -->
      <el-input-number
        style="width: 100%"
        :controls="false"
        controls-position="right"
        :precision="item.format * 1"
        size="medium"
        clearable
        :value="formData[item.code]"
        placeholder="请输入数值"
        @blur="handleQueryList"
        v-else
      />
    </div>
  </div>
</template>

<script>
import Minxins from "../Minxins";
export default {
  name: "AmountInput",
  mixins: [Minxins],
  data() {
    return {};
  },
  computed: {
    startNumber: {
      get() {
        if (this.formData[this.item.code]) {
          return this.formData[this.item.code][0];
        } else return null;
      },
      set(val) {
        if (!this.formData[this.item.code]) {
          this.$set(this.formData, this.item.code, []);
        }
        this.$set(this.formData[this.item.code], 0, val);
      },
    },

    finishNumber: {
      get() {
        if (this.formData[this.item.code]) {
          return this.formData[this.item.code][1];
        } else return null;
      },

      set(val) {
        if (!this.formData[this.item.code]) {
          this.$set(this.formData, this.item.code, []);
        }

        this.$set(this.formData[this.item.code], 1, val);
      },
    },
  },
  methods: {
    queryListWithin() {
      this.$set(this.formData, this.item.code, [
        this.startNumber,
        this.finishNumber,
      ]);
      this.$emit("queryList");
    },
    handleQueryList(e) {
      // console.log(e.target.value, this.item.format);
      this.$set(this.formData, this.item.code, e.target.value || 0);
    },
  },
};
</script> 

<style lang="less" scoped>
.chinese {
  color: #afadad;
  font-size: smaller;
}
/deep/ .el-input__inner {
  text-align: left;
  border-radius: 0;
}

.number-container {
  width: 100%;
  height: 34px;
  border: 1px solid #dfdfdf;
  border-radius: 4px;
  display: flex;
  align-items: center;
  /deep/ .el-input__inner {
    border: none;
    background-color: transparent;
  }
  &:hover {
    border-color: #107fff;
  }
}
</style>
<style lang="less">
.input {
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
}
</style>
